import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/stores/store";

const initialState = {
  selectedAddressId: 0,
  d365Token: "",
};

const slice = createSlice({
  name: "loanAppSlice",
  initialState,
  reducers: {
    changeSelectedPropertie(
      state,
      {
        payload,
      }: PayloadAction<{
        selectedAddressId: number;
      }>
    ) {
      state.selectedAddressId = payload.selectedAddressId;
    },
  },
});

export const { changeSelectedPropertie } = slice.actions;

export default slice.reducer;

export const selectAddressId = (state: RootState) => state.loanAppSlice.selectedAddressId;
